import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import PdfQTypeActivity from "../../On_going/Published/Published_Q_list/PublishQuestionType/PdfType/PdfQTypeActivity";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import StudentTableActivityCompleted from "./Table_Props/StudentTableActivityCompleted";
import ExportTablePDf from "../../../../Components/exportTablePDf";
import { Award } from "lucide-react";

const CompletedStudentListActivity = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [filterName, setFilterName] = useState("");
  const [debouncedFilter, setDebouncedFilter] = useState("");
  const [showDetails, setShowDetails] = useState(true);

  const [loading, setLoading] = useState(false);
  const [noResponse, setNoResponse] = useState(false);

  const [completeData, setCompleteData] = useState({
    completeActivitys: [],
    completeList: [],
  });

  const { completeActivitys, completeList } = completeData;

  // 🔥 Get entryType and gradeScale from activity
  const entryType = completeActivitys?.entryType || null;
  const gradeScale = completeActivitys?.gradeScaleId || null;
  const totalMarks = completeActivitys?.total_marks || 0;

  // Helper function to render grade/marks info
  const renderGradeOrMarksInfo = () => {
    // 🔥 If entryType is "Grade" - show grade scale
    if (entryType === "Grade" && gradeScale) {
      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Award size={16} style={{ color: "#6366f1" }} />
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Grade Scale:
          </span>
          <span
            style={{ fontSize: "0.9rem", fontWeight: 700, color: "#4338ca" }}
          >
            {gradeScale.name}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#6366f1",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Grade
          </span>
          <div className="d-flex gap-1 flex-wrap">
            {gradeScale.grades?.map((grade) => (
              <span
                key={grade.grade}
                className="badge"
                style={{
                  backgroundColor:
                    grade.resultStatus === "Pass" ? "#d4edda" : "#f8d7da",
                  color: grade.resultStatus === "Pass" ? "#155724" : "#721c24",
                  padding: "3px 8px",
                  borderRadius: "4px",
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                {grade.grade}: {grade.minMarks}-{grade.maxMarks}
              </span>
            ))}
          </div>
        </div>
      );
    }

    // 🔥 If entryType is "Marks" - show total marks
    if (entryType === "Marks") {
      return (
        <div className="d-flex align-items-center gap-2">
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Total Marks
          </span>
          <span
            style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}
          >
            {totalMarks || 0}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Marks
          </span>
        </div>
      );
    }

    // 🔥 If no entryType or "None" - show total marks (fallback)
    return (
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}>
          Total Marks
        </span>
        <span style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}>
          {totalMarks || 0}
        </span>
      </div>
    );
  };

  // ------------------- Debouncing -------------------
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedFilter(filterName.trim());
    }, 500);

    return () => clearTimeout(t);
  }, [filterName]);

  // ------------------- Fetch -------------------
  useEffect(() => {
    const getCompletedStudents = async () => {
      try {
        setLoading(true);
        setNoResponse(false);

        const res = await axios.get(
          `/api/v1/homework/activity/getById/${state?.completeActivity_id}`,
        );

        const completeListRes = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${
            state?.completeActivity_id
          }${debouncedFilter ? `?name=${debouncedFilter}` : ""}`,
        );

        const list = completeListRes?.data?.data || [];

        if (list.length === 0) {
          setNoResponse(true);
          setCompleteData({
            completeActivitys: res.data.data,
            completeList: [],
          });
        } else {
          setNoResponse(false);
          setCompleteData({
            completeActivitys: res.data.data,
            completeList: list,
          });
        }
      } catch (error) {
        console.log(error);
        setNoResponse(true);
      } finally {
        setLoading(false);
      }
    };

    getCompletedStudents();
  }, [debouncedFilter]);

  return (
    <>
      {/* ═══════════════════════════════════════════════════
          MAIN CONTENT
          ═══════════════════════════════════════════════════ */}
      <div
        className="orange-scrollBar"
        style={{
          width: "100%",
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* ── Modern Header ── */}
        <div className="d-flex align-items-center gap-3 w-100 mb-3">
          <div
            onClick={() => navigate("/PublishedHomeworkActivity")}
            style={{
              cursor: "pointer",
              width: "36px",
              height: "36px",
              borderRadius: "10px",
              background: "#f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img
              src="/images/Back Arrow.svg"
              alt="Back"
              style={{ width: "18px" }}
            />
          </div>

          <div className="d-flex flex-column gap-1" style={{ flex: 1 }}>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 700,
                  color: "#1e293b",
                  lineHeight: 1.3,
                }}
              >
                {completeActivitys?.name || "Activity"}
              </span>
              <span
                style={{
                  background: "#dcfce7",
                  color: "#166534",
                  border: "1px solid #bbf7d0",
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  whiteSpace: "nowrap",
                }}
              >
                Completed
              </span>
              {/* 🆕 Entry Type Badge */}
              {entryType && entryType !== "None" && (
                <span
                  style={{
                    background: entryType === "Grade" ? "#6366f1" : "#28a745",
                    color: "#fff",
                    padding: "4px 12px",
                    borderRadius: "999px",
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {entryType}
                </span>
              )}
            </div>
            <span className="fw-small text-muted" style={{ fontSize: "11px" }}>
              Dashboard / Activity / Completed / {completeActivitys?.name}
            </span>
          </div>

          {/* 🆕 Grade/Marks Info Box */}
          <div
            className="d-flex align-items-center gap-3"
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              padding: "8px 16px",
              borderRadius: "10px",
              whiteSpace: "nowrap",
            }}
          >
            {renderGradeOrMarksInfo()}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════
            ACTIVITY DETAILS CARD — COLLAPSIBLE
            ═══════════════════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #e9ecef",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          {/* Collapsible Description */}
          <div
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              overflow: "hidden",
              background: "#ffffff",
              boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
            }}
          >
            {/* Header */}
            <div
              onClick={() => setShowDetails(!showDetails)}
              className="d-flex justify-content-between align-items-center px-3 py-3 flex-wrap gap-2"
              style={{
                cursor: "pointer",
                background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
              }}
            >
              <div className="d-flex flex-column gap-2">
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span
                    style={{
                      background: "#fff",
                      padding: "6px 14px",
                      borderRadius: "999px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#166534",
                      border: "1px solid #bbf7d0",
                    }}
                  >
                    📘 {completeActivitys?.subject_id?.name}
                  </span>
                  <span
                    style={{
                      background: "#fff",
                      padding: "6px 14px",
                      borderRadius: "999px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#14532d",
                      border: "1px solid #86efac",
                    }}
                  >
                    ⏰ Completed
                  </span>
                  {/* 🆕 Entry Type Badge in Description */}
                  {entryType && entryType !== "None" && (
                    <span
                      style={{
                        background:
                          entryType === "Grade" ? "#6366f1" : "#28a745",
                        color: "#fff",
                        padding: "4px 12px",
                        borderRadius: "999px",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {entryType}
                    </span>
                  )}
                </div>
                <div>
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#166534",
                    }}
                  >
                    📝 Activity Description
                  </span>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#78716c",
                      marginTop: "2px",
                    }}
                  >
                    Click to {showDetails ? "hide" : "view"} full description
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#166534",
                  flexShrink: 0,
                  userSelect: "none",
                }}
              >
                {showDetails ? "−" : "+"}
              </div>
            </div>

            {/* Collapsible Body */}
            <div
              style={{
                maxHeight: showDetails ? "300px" : "0px",
                overflow: "hidden",
                transition: "all 0.35s ease",
              }}
            >
              <div
                className="orange-scrollBar"
                style={{
                  width: "100%",
                  padding: "18px",
                  whiteSpace: "pre-wrap",
                  lineHeight: 1.7,
                  color: "#475569",
                  fontSize: "14px",
                  maxHeight: "260px",
                  overflowY: "auto",
                }}
              >
                {completeActivitys?.description || "No description available"}
              </div>
            </div>
          </div>

          {/* Lab Card */}
          {completeActivitys?.activity_type === "Lab" &&
            completeActivitys?.lab_ref && (
              <div className="mt-4 mb-2">
                <div
                  className="p-3"
                  style={{
                    backgroundColor: "#fff7ed",
                    border: "2px solid #f97316",
                    borderRadius: "16px",
                  }}
                >
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <img
                      src={completeActivitys.lab_ref.thumbnailUrl}
                      alt={completeActivitys.lab_ref.title}
                      style={{
                        width: "130px",
                        height: "85px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid #fdba74",
                        flexShrink: 0,
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                        <span
                          style={{
                            fontWeight: 700,
                            color: "#c2410c",
                            fontSize: "1.05rem",
                          }}
                        >
                          {completeActivitys.lab_ref.title}
                        </span>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "#ffedd5",
                            color: "#c2410c",
                            fontSize: "0.75rem",
                            padding: "6px 10px",
                          }}
                        >
                          {completeActivitys.lab_ref.resourceType}
                        </span>
                      </div>
                      <p
                        style={{
                          color: "#7c2d12",
                          fontSize: "0.85rem",
                          lineHeight: 1.5,
                          marginBottom: "8px",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {completeActivitys.lab_ref.description}
                      </p>
                      <span style={{ fontSize: "0.8rem", color: "#9a3412" }}>
                        {completeActivitys.lab_ref.estimatedDurationMinutes}{" "}
                        mins
                      </span>
                    </div>
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "#f97316",
                        color: "#ffffff",
                        borderRadius: "10px",
                        padding: "8px 20px",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        border: "none",
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        const previewData = {
                          selectedLab: completeActivitys.lab_ref,
                          activityData: {
                            title: completeActivitys.name,
                            description: completeActivitys.description,
                            className: completeActivitys?.standard_id?.name,
                            subjectName: completeActivitys?.subject_id?.name,
                            chapterName:
                              completeActivitys?.chapter_id?.chapterName || "",
                            duration:
                              completeActivitys?.duration || "20 minutes",
                          },
                        };

                        localStorage.setItem(
                          "activityPreviewData",
                          JSON.stringify(previewData),
                        );

                        const features = [
                          "toolbar=no",
                          "location=no",
                          "directories=no",
                          "status=no",
                          "menubar=no",
                          "scrollbars=yes",
                          "resizable=yes",
                          "fullscreen=yes",
                          `width=${window.screen.availWidth}`,
                          `height=${window.screen.availHeight}`,
                          "top=0",
                          "left=0",
                        ].join(",");

                        const newWindow = window.open(
                          "/activity-lab-preview.html",
                          "_blank",
                          features,
                        );

                        if (newWindow) {
                          newWindow.moveTo(0, 0);
                          newWindow.resizeTo(
                            window.screen.availWidth,
                            window.screen.availHeight,
                          );
                          newWindow.focus();
                        }
                      }}
                    >
                      Open Activity
                    </button>
                  </div>
                </div>
              </div>
            )}

          {/* PDF Attachments */}
          <div className="mt-4 pdf_container_activity_review d-flex flex-wrap gap-2">
            {completeActivitys?.attachments?.length !== 0 &&
              completeActivitys?.attachments?.map((attachments, idx) => (
                <PdfQTypeActivity
                  key={idx}
                  publishedAttachData={completeActivitys}
                  attachments={attachments}
                />
              ))}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════
            STUDENT LIST CARD
            ═══════════════════════════════════════════════════ */}
        <div
          className="d-flex flex-column"
          style={{
            backgroundColor: "white",
            width: "100%",
            borderRadius: "12px",
            border: "1px solid #e9ecef",
            overflow: "hidden",
          }}
        >
          {/* Top Bar */}
          <div className="px-3 py-3 d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                style={{
                  background: "#dcfce7",
                  color: "#166534",
                  border: "1px solid #bbf7d0",
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  whiteSpace: "nowrap",
                }}
              >
                Completed
              </span>
              <span style={{ fontWeight: 600, color: "#475569" }}>
                {completeActivitys?.subject_id?.name}
              </span>
            </div>

            <div className="d-flex align-items-center gap-3 flex-wrap">
              <div style={{ position: "relative", width: "260px" }}>
                <input
                  className="form-control mr-sm-2 m-0 name_search_box"
                  type="search"
                  value={filterName}
                  placeholder="Search by Student Name"
                  aria-label="Search"
                  onChange={(e) => setFilterName(e.target.value)}
                  style={{
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    paddingLeft: "36px",
                    fontSize: "0.85rem",
                  }}
                />
                <img
                  className="name_search_icon"
                  src="/images/search icon.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "16px",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Table — Scrollable Area */}
          <div
            className="orange-scrollBar"
            style={{
              overflow: "auto",
              maxHeight: "calc(100vh - 360px)",
              minHeight: "250px",
              borderTop: "1px solid #f1f5f9",
              position: "relative",
            }}
          >
            <Table
              responsive
              className="student_profile_table"
              borderless
              style={{ textAlign: "center", marginBottom: 0 }}
            >
              <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                <tr>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Name
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Roll No.
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Class
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Division
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Date submitted
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {entryType === "Grade" ? "Grade" : "Marks"}
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* Loader */}
                {loading && completeList.length === 0 && (
                  <tr>
                    <td
                      colSpan="7"
                      style={{ padding: "50px 20px", textAlign: "center" }}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src="/gif/LoaderDot.gif"
                          alt="loading"
                          style={{ height: "50px" }}
                        />
                        <div
                          className="mt-2 text-muted"
                          style={{ fontSize: "13px" }}
                        >
                          Loading students...
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {/* Empty State */}
                {!loading && noResponse && (
                  <tr>
                    <td
                      colSpan="7"
                      style={{ padding: "50px 20px", textAlign: "center" }}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src="/images/no-data.png"
                          alt="No data"
                          style={{ width: "80px", opacity: 0.6 }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                        <div className="mt-3 fw-bold text-muted">
                          No student found
                        </div>
                        <div
                          className="text-muted"
                          style={{ fontSize: "12px", marginTop: "4px" }}
                        >
                          Try searching with a different name.
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {/* Data Rows - Pass entryType and gradeScaleId to child */}
                {!loading &&
                  !noResponse &&
                  completeList &&
                  completeList.length > 0 &&
                  completeList.map((completeSLData) => (
                    <StudentTableActivityCompleted
                      key={completeSLData.id}
                      completeSLData={completeSLData}
                      completeActivitys={completeActivitys}
                      completeActivity_id={state?.completeActivity_id}
                      entryType={entryType}
                      gradeScaleId={gradeScale}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompletedStudentListActivity;
